/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthStrictHttpResponse } from '../../auth-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RoleModel } from '../../models/role-model';

export interface RoleIdGet$Params {
  id: string;
}

export function roleIdGet(http: HttpClient, rootUrl: string, params: RoleIdGet$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<RoleModel>> {
  const rb = new RequestBuilder(rootUrl, roleIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AuthStrictHttpResponse<RoleModel>;
    })
  );
}

roleIdGet.PATH = '/Role/{id}';
